module.exports = __webpack_public_path__ + "img/nemuno sakata_sc1.353774f1.png";